module.exports = __webpack_public_path__ + "static/media/0023_LES_MURS_TRUFFLE_W_VTR2100.cea6a3b1.png";